import React, { useEffect, useRef, useState } from 'react';
import { AppleIcon, SmartphoneIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { appLinks } from '../data/appTour';
interface JoinPlatformButtonProps {
  /** Classes applied to the trigger button so it can match its surrounding hero/CTA. */
  className?: string;
  label?: string;
  align?: 'center' | 'left';
}
export function JoinPlatformButton({
  className = '',
  label = 'Join the Platform',
  align = 'center'
}: JoinPlatformButtonProps) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const onPointerDown = (event: MouseEvent) => {
      if (!containerRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);
  const optionStyles = 'flex items-center gap-3 px-5 py-3.5 text-sm font-medium text-charcoal hover:bg-purple-50 hover:text-purple-800 transition-colors duration-200 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-purple-600';
  return <div ref={containerRef} className="relative w-full sm:w-auto" data-id="element-220" data-mp="157ku8h4q61am">
      <Button variant="primary" size="lg" onClick={() => setOpen(value => !value)} aria-expanded={open} aria-haspopup="true" aria-controls="get-the-app-options" className={className} data-id="element-221" data-mp="1087x93k53dub">
        {label}
      </Button>

      {open && <div id="get-the-app-options" className={`absolute z-50 mt-3 w-64 overflow-hidden rounded-2xl border border-purple-200 bg-white shadow-xl ${align === 'center' ? 'left-1/2 -translate-x-1/2' : 'left-0 sm:left-0'}`} data-id="element-222" data-mp="2pk0cvjsmcd5h">
          <p className="px-5 pt-4 pb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-purple-700" data-id="element-223" data-mp="1n6m1ezwemcum">
            Download the app
          </p>
          <a href={appLinks.apple} target="_blank" rel="noopener noreferrer" className={`${optionStyles} border-t border-purple-100`} data-id="element-224" data-mp="1w9dc2xhgh4l7">
            <AppleIcon aria-hidden="true" className="w-4 h-4 text-purple-700" data-id="element-225" data-mp="13job2k4qx4jl" />
            Download for iPhone
          </a>
          <a href={appLinks.android} target="_blank" rel="noopener noreferrer" className={`${optionStyles} border-t border-purple-100`} data-id="element-226" data-mp="18i7w8ibimcaw">
            <SmartphoneIcon aria-hidden="true" className="w-4 h-4 text-purple-700" data-id="element-227" data-mp="ftk9eib4bev8" />
            Download for Android
          </a>
        </div>}
    </div>;
}